import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  kk: {
    translation: {
      brand: 'Almus',
      company: 'ТОО «Перспективные материалы и технологии»',
      nav: {
        home: 'Басты бет',
        products: 'Ассортимент',
        blog: 'Блог',
        pricing: 'Бағалар',
        about: 'Біз туралы',
        contact: 'Байланыс',
      },
      hero: {
        eyebrow: 'ТОО «Перспективные материалы и технологии» · Алматы',
        title: 'Almus гранулды жемдері — пайдалы мал шаруашылығына жол',
        text: 'Almus гранулды жемдері малдың салмақ қосуын 20%-ға дейін, құстың жұмыртқалауын 15%-ға, сүттілігін 20%-ға арттырады. Табиғи құрам, ыңғайлы сақтау, ең көп қоректік заттар!',
        cta: 'Өтініш қалдыру',
      },
      seo: { title: 'Almus — Гранулды жемдер | Алматы' },
      stats: {
        eyebrow: 'Тиімділік',
        title: 'Гранулды жем ALMUS не береді?',
        subtitle: 'Табиғи құрам, ыңғайлы сақтау, ең көп қоректік заттар — нәтиже сандық көрсеткіштерде.',
        items: [
          { value: '+20%', title: 'Сүт өнімділігі', text: 'сүтті сиырлардың өнімі артады' },
          { value: '+15–20%', title: 'Тірі салмақ', text: 'КРС тезірек семіреді' },
          { value: '+15%', title: 'Жұмыртқалау', text: 'құстардың жұмыртқалауы артады' },
          { value: '1,2 кг', title: 'Тәуліктік өсім', text: 'семіртілетін бұқалар' },
        ],
      },
      videos: {
        eyebrow: 'Өндіріс',
        title: 'Видеолар',
        subtitle: 'ALMUS жемдері өндірісі мен далалық жұмыстар туралы.',
        caption1: 'Далалық жұмыстар',
        caption2: 'Өнім туралы таныстыру',
      },
      mission: {
        title: 'Біздің миссия',
        text: 'Шаруаларды сапалы әрі тиімді жемдермен қамтамасыз ету, малдың өнімділігін арттыру және ауыл шаруашылығына экономикалық пайда әкелу.',
        valuesTitle: 'Құндылықтар',
        values: ['Экологиялық', 'Инновация', 'Қолжетімділік', 'Тиімділік'],
      },
      products: {
        title: 'Ассортимент',
        learnMore: 'Толығырақ',
      },
      product: {
        composition: 'Құрамы',
        benefits: 'Артықшылықтары',
        instructions: 'Қолдану нұсқаулығы',
        notFound: 'Өнім табылмады.',
      },
      reviews: {
        title: 'Пікірлер',
      },
      productItems: {
        krs: { title: 'КРС-ға арналған жем', short: 'КРС', desc: 'Ірі қара малға арналған толықрационды гранулды жем — қажетті қоректік заттар, макро- және микроэлементтер балансы. Өсімді жақсартып, сүттілікті арттырады, малдың иммунитетін мықтылайды.' },
        mrs: { title: 'МРС-ке арналған жем', short: 'МРС', desc: 'Ұсақ қара малға арнайы жасалған жем — малдың энергия мен ақуызға деген жоғары қажеттілігін ескереді.' },
        birds: { title: 'Құсқа арналған жем', short: 'Құс', desc: 'Құсқа арналған гранулды жем өсімді жеделдетіп, жұмыртқалауды арттырады, сүйекті мықтылайды.' },
        pigs: { title: 'Шошқаға арналған жем', short: 'Шошқа', desc: 'Шошқаға арналған толыққанды комбикорм — энергия мен протеинге деген жоғары қажеттілігін ескеріп жасалған.' },
        universal: { title: 'Универсалды жем қоспалары', short: 'Универсалды', desc: 'Ауыл шаруашылығы жануарларының барлық түріне арналған гранулды жем.' },
      },
      productComposition: {
        protein: 'Ақуыздар',
        fiber: 'Жасұнық',
        vitamins: 'Дәрумендер',
        minerals: 'Минералдар',
        fat: 'Майлар',
        energy: 'Энергетикалық құндылық',
        extra: 'Қосымша',
        amino: 'Аминқышқылдары',
        starch: 'Крахмал',
        omega: 'Омега-3',
        balance: 'Баланс',
        formula: 'Формула',
        shelf: 'Сақтау мерзімі',
      },
      productBenefits: {
        krs: ['Тірі салмақты 15–20% тезірек жинатады', 'Сүтті сиырлардың сүтін арттырады', 'Асқазан-ішек және рахит аурулары қаупін азайтады'],
        mrs: ['Жүн жабынын жақсартады', 'Малдың өсімталдығын арттырады', 'Тірі салмақты 10–12% тезірек жинатайды'],
        birds: ['Жұмыртқалауды 15%-ға дейін арттырады', 'Құстың иммунитетін мықтылайды', 'Жем шығынын азайтады'],
        pigs: ['Тірі салмақты 20% тезірек жинатайды', 'Ет сапасын жақсартады', 'Иммунитетті мықтылайды'],
        universal: ['Жануарлардың әр түріне әмбебап', 'Сақтау мен тасымалдау ыңғайлы', 'Жемдеу шығынын азайтады'],
      },
      productInstructions: {
        usage: 'Қолдану нұсқаулығы',
        krs: {
          young: 'Жас мал (6 айға дейін)',
          youngNote: 'Күніне 3–4 рет азықтандыру',
          dairy: 'Сүтті сиырлар',
          dairyNote: 'Сүт 20%-ға артады',
          bull: 'Семіртілетін бұқалар',
          bullNote: 'Тәулігіне 1,2 кг-ға дейін өсім',
        },
      },
      blogItems: {
        'kak-pravilno-kormit-krs': {
          title: 'ҚРС-ты қалай дұрыс азықтандыру керек?',
          excerpt: 'Ірі қара малды азықтандырудың негізгі принциптері.',
          content: `Азықтандырудың негізгі принциптері:
• Тірі салмақ жинауға ақуыз бен көмірсудың балансы
• Сүйек тінін мықтылайтын минералдар мен дәрумендер
• Оңтайлы суландыру — тәулігіне 30–40 литр су

Неліктен гранулды жем жақсы?
✅ Артық қалдықсыз толық жеп қойылады
✅ Қосымша дайындауды қажет етпейді
✅ Жақсы нәтиже береді (15–20% тиімдірек)`,
        },
        'laboratornye-ispytaniya': {
          title: 'Жаңа жемдер зертханада сынақтан өтуде',
          excerpt: 'Компания жақсартылған формуламен жаңа жем түрлерін сынақтан өткізуде.',
          content: `ТОО «Перспективные материалы и технологии» компаниясы жаңа жем түрлерін сынақтан өткізуде:
• Қорытындыны жақсартатын пробиотикті жем
• Ірі қараны семіртуге арналған ақуызы жоғары жем
• Экологиялық мал шаруашылығына соясыз табиғи жем

Жем талдауы Қазақстанның жетекші зертханаларында жүргізіледі.`,
        },
      },
      reviewer1: {
        name: 'Алимбек',
        role: 'Фермер',
        text: '10 жыл фермер болып жұмыс істеймін, әр түрлі жемдерді сынап көрдім. Almus гранулды жемін қолдана бастағанда сиырларымның тірі салмағы тезірек өсіп, сүті 15–20%-ға артқанын байқадым.',
      },
      reviewer2: {
        name: 'Азамат',
        role: 'Фермер',
        text: 'Мен бұқа семіртпемін. Almus жемдерімен бұқаларым тәулігіне 1,2 кг-ға дейін тірі салмақ жинай бастады. Тамаша өнім, сақтауға ыңғайлы!',
      },
      blog: {
        title: 'Блог',
        notFound: 'Мақала табылмады.',
      },
      pricing: {
        title: 'Бағалар',
        text: 'Бағаларды жаңарту үшін компаниядан ағымдағы баға тізімін алу керек.',
        cta: 'Өтініш қалдырыңыз — менеджер бағаны және жеткізу шарттарын хабарлайды.',
      },
      about: {
        title: 'Біз туралы',
        intro: 'ТОО «Перспективные материалы и технологии» — Almus брендімен гранулды жемдер өндіретін қазақстандық компания.',
        mission: 'Миссия',
        values: 'Құндылықтар',
        team: 'Команда',
        teamText: 'Команда фотосуреттері мен аты-жөнін осында орналастыру керек.',
      },
      contact: {
        title: 'Байланыс',
        address: 'Мекенжай',
        phone: 'Телефон',
        email: 'Email',
        whatsapp: 'WhatsApp',
        social: 'Әлеуметтік желілер',
        name: 'Атыңыз',
        company: 'Шаруашылық / компания',
        phoneLabel: 'Телефон',
        message: 'Хабарлама',
        submit: 'WhatsApp арқылы жіберу',
        formSubject: '*ALMUS сайтынан өтініш (pmt-almus.kz)*',
        ariaLanguage: 'Тілді таңдау',
        ariaMenu: 'Мәзір',
      },
      footer: {
        rights: 'Барлық құқықтар қорғалған.',
      },
    },
  },
  ru: {
    translation: {
      brand: 'Almus',
      company: 'ТОО «Перспективные материалы и технологии»',
      nav: {
        home: 'Главная',
        products: 'Ассортимент',
        blog: 'Блог',
        pricing: 'Цены',
        about: 'О нас',
        contact: 'Контакты',
      },
      hero: {
        eyebrow: 'ТОО «Перспективные материалы и технологии» · Алматы',
        title: 'Гранулированные корма ALMUS — ваш путь к прибыльному фермерству!',
        text: 'Наши гранулированные корма увеличивают прирост животных до 20%, повышают яйценоскость птицы на 15% и удои молока на 20%. Натуральный состав, удобство хранения, максимум питательных веществ!',
        cta: 'Оставить заявку',
      },
      seo: { title: 'Almus — Гранулированные корма | Алматы' },
      stats: {
        eyebrow: 'Эффективность',
        title: 'Что даёт гранулированный корм ALMUS',
        subtitle: 'Натуральный состав, удобство хранения, максимум питательных веществ — результат в цифрах.',
        items: [
          { value: '+20%', title: 'Молоко', text: 'удои молочных коров растут' },
          { value: '+15–20%', title: 'Живая масса', text: 'ускоренный откорм КРС' },
          { value: '+15%', title: 'Яйценоскость', text: 'птица несётся чаще' },
          { value: '1,2 кг', title: 'Прирост в сутки', text: 'бычки на откорме' },
        ],
      },
      videos: {
        eyebrow: 'Производство',
        title: 'Видео',
        subtitle: 'Производство кормов ALMUS и полевые работы.',
        caption1: 'Полевые работы',
        caption2: 'Презентация продукта',
      },
      mission: {
        title: 'Наша миссия',
        text: 'Обеспечить фермеров качественными и эффективными кормами, для повышения продуктивности животных и обеспечения экономической выгоды сельского хозяйства.',
        valuesTitle: 'Ценности',
        values: ['Экологичность', 'Инновации', 'Доступность', 'Эффективность'],
      },
      products: {
        title: 'Ассортимент',
        learnMore: 'Подробнее',
      },
      productItems: {
        krs: { title: 'Корма для КРС', short: 'КРС', desc: 'Полнорационный гранулированный корм для крупного рогатого скота содержит баланс необходимых питательных веществ, макро- и микроэлементов. Улучшает рост, повышает удои, укрепляет иммунитет животных.' },
        mrs: { title: 'Корма для МРС', short: 'МРС', desc: 'Специально разработанный корм для мелкого рогатого скота, учитывающий высокие потребности животных в энергии и белке.' },
        birds: { title: 'Корма для птицы', short: 'Птица', desc: 'Гранулированный корм для птиц ускоряет рост, увеличивает яйценоскость, укрепляет кости.' },
        pigs: { title: 'Корма для свиней', short: 'Свиньи', desc: 'Полноценный комбикорм для свиней, разработанный с учетом их высокой потребности в энергии и протеине.' },
        universal: { title: 'Универсальные кормовые смеси', short: 'Универсальные', desc: 'Гранулированный корм для всех видов сельскохозяйственных животных.' },
      },
      productComposition: {
        protein: 'Белки',
        fiber: 'Клетчатка',
        vitamins: 'Витамины',
        minerals: 'Минералы',
        fat: 'Жиры',
        energy: 'Энергетическая ценность',
        extra: 'Дополнительно',
        amino: 'Аминокислоты',
        starch: 'Крахмал',
        omega: 'Омега-3',
        balance: 'Баланс',
        formula: 'Формула',
        shelf: 'Срок хранения',
      },
      productBenefits: {
        krs: ['Ускоряет набор живой массы на 15–20% быстрее', 'Повышает удои молочных коров', 'Снижает риск заболеваний ЖКТ и рахита'],
        mrs: ['Улучшает шерстный покров', 'Повышает плодовитость животных', 'Ускоряет набор живой массы на 10–12%'],
        birds: ['Увеличивает яйценоскость до 15%', 'Укрепляет иммунитет птицы', 'Минимизирует потери корма'],
        pigs: ['Ускоряет набор живой массы на 20%', 'Улучшает качество мяса', 'Укрепляет иммунитет'],
        universal: ['Универсален для разных видов животных', 'Удобство хранения и транспортировки', 'Снижает затраты на кормление'],
      },
      productInstructions: {
        usage: 'Инструкция по применению',
        krs: {
          young: 'Молодняк (до 6 месяцев)',
          youngNote: '3–4-кратное кормление',
          dairy: 'Дойные коровы',
          dairyNote: 'Увеличение удоев на 20%',
          bull: 'Быки на откорме',
          bullNote: 'Прирост до 1,2 кг/гол',
        },
      },
      blogItems: {
        'kak-pravilno-kormit-krs': {
          title: 'Как правильно кормить КРС?',
          excerpt: 'Основные принципы кормления крупного рогатого скота.',
          content: `Основные принципы кормления:
• Баланс белков и углеводов для набора живой массы
• Минералы и витамины для укрепления костной ткани
• Оптимальное поение — 30–40 литров воды в сутки

Почему гранулированный корм лучше?
✅ Полностью съедается без остатков
✅ Не требует дополнительной подготовки
✅ Дает хорошие результаты (на 15–20% эффективнее)`,
        },
        'laboratornye-ispytaniya': {
          title: 'Новые корма проходят испытания в лаборатории',
          excerpt: 'Компания тестирует новые виды кормов с улучшенной формулой.',
          content: `Компания тестирует новые виды кормов:
• Корм с пробиотиками для лучшего пищеварения
• Высокобелковый корм для откорма КРС
• Экологический корм без сои для органического животноводства

Анализ кормов проводится в ведущих лабораториях Казахстана.`,
        },
      },
      reviewer1: {
        name: 'Алимбек',
        role: 'Фермер',
        text: 'Работаю фермером 10 лет, пробовал разные корма. Когда начал использовать гранулированный корм Almus, я заметил, что мои коровы стали быстрее набирать живую массу, удои выросли на 15–20%.',
      },
      reviewer2: {
        name: 'Азамат',
        role: 'Фермер',
        text: 'Я занимаюсь откормом бычков. С кормами Almus мои бычки стали набирать живую массу до 1,2 кг в сутки. Отличный продукт, удобный в хранении!',
      },
      product: {
        composition: 'Состав',
        benefits: 'Преимущества',
        instructions: 'Инструкция по применению',
        notFound: 'Продукт не найден.',
      },
      reviews: {
        title: 'Отзывы',
      },
      blog: {
        title: 'Блог',
        notFound: 'Статья не найдена.',
      },
      pricing: {
        title: 'Цены',
        text: 'Для обновления цен необходимо получить актуальный прайс-лист от компании.',
        cta: 'Оставьте заявку — менеджер сообщит цены и условия доставки.',
      },
      about: {
        title: 'О нас',
        intro: 'ТОО «Перспективные материалы и технологии» — казахстанская компания, производящая гранулированные корма под брендом Almus.',
        mission: 'Миссия',
        values: 'Ценности',
        team: 'Команда',
        teamText: 'Здесь будут размещены фотографии команды с ФИО и должностями.',
      },
      contact: {
        title: 'Контакты',
        address: 'Адрес',
        phone: 'Телефон',
        email: 'Email',
        whatsapp: 'WhatsApp',
        social: 'Соцсети',
        name: 'Ваше имя',
        company: 'Хозяйство / компания',
        phoneLabel: 'Телефон',
        message: 'Сообщение',
        submit: 'Отправить через WhatsApp',
        formSubject: '*Заявка с сайта ALMUS (pmt-almus.kz)*',
        ariaLanguage: 'Выбор языка',
        ariaMenu: 'Меню',
      },
      footer: {
        rights: 'Все права защищены.',
      },
    },
  },
  en: {
    translation: {
      brand: 'Almus',
      company: 'LLP «Perspective Materials and Technologies»',
      nav: {
        home: 'Home',
        products: 'Products',
        blog: 'Blog',
        pricing: 'Pricing',
        about: 'About',
        contact: 'Contact',
      },
      hero: {
        eyebrow: 'LLP «Perspective Materials and Technologies» · Almaty',
        title: 'Almus Pelleted Feed — your path to profitable farming!',
        text: 'Our pelleted feed increases animal weight gain by up to 20%, improves poultry laying by 15%, and boosts milk yield by 20%. Natural composition, easy storage, maximum nutrients!',
        cta: 'Request a quote',
      },
      seo: { title: 'Almus — Pelleted Feed | Almaty' },
      stats: {
        eyebrow: 'Efficiency',
        title: 'What ALMUS pelleted feed delivers',
        subtitle: 'Natural composition, easy storage, maximum nutrients — results in numbers.',
        items: [
          { value: '+20%', title: 'Milk yield', text: 'dairy cows produce more' },
          { value: '+15–20%', title: 'Live weight', text: 'faster cattle fattening' },
          { value: '+15%', title: 'Egg production', text: 'poultry lay more often' },
          { value: '1.2 kg', title: 'Daily gain', text: 'fattening bulls' },
        ],
      },
      videos: {
        eyebrow: 'Production',
        title: 'Videos',
        subtitle: 'ALMUS feed production and field operations.',
        caption1: 'Field operations',
        caption2: 'Product presentation',
      },
      mission: {
        title: 'Our mission',
        text: 'To provide farmers with high-quality and efficient feed that improves animal productivity and delivers economic benefit to agriculture.',
        valuesTitle: 'Values',
        values: ['Eco-friendly', 'Innovation', 'Accessibility', 'Efficiency'],
      },
      products: {
        title: 'Product range',
        learnMore: 'Learn more',
      },
      productItems: {
        krs: { title: 'Cattle feed', short: 'Cattle', desc: 'Complete pelleted feed for cattle with balanced nutrients, macro- and micro-elements. Improves growth, milk yield, and immunity.' },
        mrs: { title: 'Small ruminant feed', short: 'Sheep & goats', desc: 'Special feed for sheep and goats considering high energy and protein needs.' },
        birds: { title: 'Poultry feed', short: 'Poultry', desc: 'Pelleted feed for poultry accelerates growth, increases egg production, and strengthens bones.' },
        pigs: { title: 'Pig feed', short: 'Pigs', desc: 'Complete compound feed for pigs developed with their high energy and protein needs in mind.' },
        universal: { title: 'Universal feed mixes', short: 'Universal', desc: 'Pelleted feed suitable for all types of farm animals.' },
      },
      productComposition: {
        protein: 'Protein',
        fiber: 'Fiber',
        vitamins: 'Vitamins',
        minerals: 'Minerals',
        fat: 'Fats',
        energy: 'Energy value',
        extra: 'Additional',
        amino: 'Amino acids',
        starch: 'Starch',
        omega: 'Omega-3',
        balance: 'Balance',
        formula: 'Formula',
        shelf: 'Shelf life',
      },
      productBenefits: {
        krs: ['Accelerates weight gain by 15–20%', 'Increases milk yield in dairy cows', 'Reduces digestive and rickets risks'],
        mrs: ['Improves wool coat', 'Increases animal fertility', 'Accelerates weight gain by 10–12%'],
        birds: ['Increases egg production up to 15%', 'Strengthens poultry immunity', 'Minimizes feed losses'],
        pigs: ['Accelerates weight gain by 20%', 'Improves meat quality', 'Strengthens immunity'],
        universal: ['Universal for different animal types', 'Easy storage and transport', 'Reduces feeding costs'],
      },
      productInstructions: {
        usage: 'Feeding instructions',
        krs: {
          young: 'Young stock (up to 6 months)',
          youngNote: '3–4 feedings per day',
          dairy: 'Dairy cows',
          dairyNote: 'Milk yield up 20%',
          bull: 'Fattening bulls',
          bullNote: 'Gain up to 1.2 kg/head',
        },
      },
      blogItems: {
        'kak-pravilno-kormit-krs': {
          title: 'How to feed cattle properly',
          excerpt: 'Basic principles of feeding cattle.',
          content: `Basic feeding principles:
• Balance of proteins and carbohydrates for weight gain
• Minerals and vitamins for strong bones
• Optimal drinking — 30–40 liters per day

Why pelleted feed is better:
✅ Fully consumed without leftovers
✅ No extra preparation needed
✅ Better results (15–20% more effective)`,
        },
        'laboratornye-ispytaniya': {
          title: 'New feeds tested in the laboratory',
          excerpt: 'The company tests new feed formulas.',
          content: `The company tests new feed formulas:
• Feed with probiotics for better digestion
• High-protein feed for cattle fattening
• Eco feed without soy for organic livestock

Analysis is conducted in leading Kazakhstan laboratories.`,
        },
      },
      reviewer1: {
        name: 'Alimbek',
        role: 'Farmer',
        text: 'I have been a farmer for 10 years and tried different feeds. Since switching to Almus pelleted feed, my cows gained weight faster and milk yield rose by 15–20%.',
      },
      reviewer2: {
        name: 'Azamat',
        role: 'Farmer',
        text: 'I fatten bulls, and fast growth is important for me. With Almus feeds my bulls gained up to 1.2 kg per day. Great product, easy to store!',
      },
      product: {
        composition: 'Composition',
        benefits: 'Benefits',
        instructions: 'Feeding instructions',
        notFound: 'Product not found.',
      },
      reviews: {
        title: 'Testimonials',
      },
      blog: {
        title: 'Blog',
        notFound: 'Article not found.',
      },
      pricing: {
        title: 'Pricing',
        text: 'Current prices need to be requested from the company.',
        cta: 'Leave a request — a manager will share prices and delivery terms.',
      },
      about: {
        title: 'About us',
        intro: 'LLP «Perspective Materials and Technologies» is a Kazakh company producing pelleted feed under the Almus brand.',
        mission: 'Mission',
        values: 'Values',
        team: 'Team',
        teamText: 'Team photos with full names and positions will be placed here.',
      },
      contact: {
        title: 'Contact us',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        whatsapp: 'WhatsApp',
        social: 'Social media',
        name: 'Your name',
        company: 'Farm / company',
        phoneLabel: 'Phone',
        message: 'Message',
        submit: 'Send via WhatsApp',
        formSubject: '*Request from ALMUS website (pmt-almus.kz)*',
        ariaLanguage: 'Language selection',
        ariaMenu: 'Menu',
      },
      footer: {
        rights: 'All rights reserved.',
      },
    },
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: ['ru', 'kk'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

const applyDocumentMeta = (lng) => {
  const base = lng.split('-')[0]
  document.documentElement.lang = base
  document.title = i18n.t('seo.title')
}

applyDocumentMeta(i18n.resolvedLanguage || 'kk')
i18n.on('languageChanged', applyDocumentMeta)

export default i18n
